import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { normalizeWorkTime } from '@/shared/helpers/workTime.ts';
import { ILocation, TDateRange } from '@/shared/types/app.types.ts';
import { LocationType } from '@/shared/types/location.types.ts';

interface ISettingsStore {
	id: number | null;
	workTime: TDateRange | null;
	carNumber: { label: string; value: string } | null;
	location: ILocation | null;
	currentLocation: Omit<LocationType, 'children'> | null;
	setSettingsId: (id: ISettingsStore['id']) => void;
	setWorkTime: (workTime: ISettingsStore['workTime']) => void;
	setCarNumber: (carNumber: ISettingsStore['carNumber']) => void;
	setLocation: (location: ISettingsStore['location']) => void;
	setCurrentLocation: (location: ISettingsStore['currentLocation']) => void;
	updateState: (newState: {
		id: ISettingsStore['id'];
		workTime: ISettingsStore['workTime'];
		carNumber: ISettingsStore['carNumber'];
		location: ISettingsStore['location'];
		currentLocation: ISettingsStore['currentLocation'];
	}) => void;
}

export const useSettingsStore = create<ISettingsStore>()(
	persist(
		(set, get) => ({
			id: null,
			workTime: null,
			carNumber: null,
			location: null,
			// location: { parking: [], route: [] },
			currentLocation: null,
			setSettingsId: (id) => set((state) => ({ id })),
			setWorkTime: (workTime) => set((state) => ({ workTime })),
			setCarNumber: (carNumber) => set((state) => ({ carNumber })),
			setLocation: (location) => set((state) => ({ location })),
			setCurrentLocation: (currentLocation) => set((state) => ({ currentLocation })),
			updateState: (newState) => set((state) => ({ ...newState })),
		}),
		{
			name: 'settings',
			// В сохранённом состоянии могло остаться незаданное рабочее время — приводим к дефолту
			merge: (persisted, current) => {
				const state = { ...current, ...(persisted as Partial<ISettingsStore>) };
				if (state.workTime) state.workTime = normalizeWorkTime(state.workTime);
				return state;
			},
		},
	),
);

export const getSettings = () => {
	const { workTime, carNumber, location, currentLocation } = useSettingsStore.getState();

	return {
		workTime,
		carNumber,
		location,
		currentLocation,
	};
};
